import { render, staticRenderFns } from "./detailComp.vue?vue&type=template&id=05464bf2&scoped=true&"
import script from "./index.ts?vue&type=script&lang=ts&"
export * from "./index.ts?vue&type=script&lang=ts&"
import style0 from "./detailComp.vue?vue&type=style&index=0&id=05464bf2&scoped=true&lang=scss&"
import style1 from "./detailComp.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05464bf2",
  null
  
)

export default component.exports